import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { BtnLoaderSize } from '@ux/components/btn-loader/entities/btn-loader-styles';
import { loaderColors } from '@ux/entities/loader-colors';

@Component({
  selector: 'app-btn-loader',
  templateUrl: './btn-loader.component.html',
  styleUrls: ['./btn-loader.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class BtnLoaderComponent {

  private btnClass: string = 'lds-dual-ring';

  @Input() classColor: string = loaderColors.WHITE;
  @Input() btnSize: BtnLoaderSize = BtnLoaderSize.RG;

  get className(): string {
    return `${this.btnClass} ${this.classColor}`;
  }

  get sizePX(): string {
    return `${this.btnSize}px`;
  }

  get borderWith(): string {
    switch(this.btnSize) {
      case BtnLoaderSize.MD:
      case BtnLoaderSize.RG:
      case BtnLoaderSize.SM:
        return '3px';
      default:
        return '2px';
    }
  }

  get styles(): { [key: string]: string } {
    return { 'width': this.sizePX, 'height': this.sizePX, 'border-width': this.borderWith };
  }

}
